import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconSkipBack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.86922 2.81251L4.03105 1.47733L2.82476 1.33337L2.44727 4.44779C2.42779 4.6085 2.47427 4.77023 2.57624 4.89658C2.67821 5.02292 2.82711 5.10326 2.98942 5.11951L5.99939 5.42089L6.12138 4.22141L4.28973 4.03801C5.26351 3.15136 6.56076 2.61094 7.98422 2.61094C11.0021 2.61094 13.4517 5.04155 13.4517 8.03603C13.4517 11.0305 11.0021 13.4611 7.98422 13.4611C5.84171 13.4611 3.9842 12.2361 3.08741 10.4507L2 10.9885C3.09418 13.1668 5.36295 14.6667 7.98422 14.6667C11.6731 14.6667 14.6667 11.6963 14.6667 8.03603C14.6667 4.37573 11.6731 1.40536 7.98422 1.40536C6.43221 1.40536 5.00345 1.93142 3.86922 2.81251Z",
		fill: "#5C5C5C"
	})
});
export default SvgIconSkipBack;
